<template>
  <h1 id="page-title">
    <router-link v-if="link" :to="link" exact>{{ title }}</router-link>
    <span v-else>{{ title }}</span>
  </h1>
</template>

<script>
export default {
  name: 'header-title',
  props: {
    link: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<style lang="sass">
  @import ../assets/styles/scss/variables.scss
  @import ../assets/styles/scss/mixins.scss

  #page-title
    text-align: right
    margin: 0
    font-size: #{$titleBaseFontSize}pt
    line-height: #{$titleBaseLineHeight}px

    > a
      color: $black
      text-decoration: none

    @media screen and (min-width: $break-small)
      font-size: #{$titleBaseFontSize + 5}pt
      line-height: #{$titleBaseLineHeight + 5}px

    @media screen and (min-width: $break-medium)
      font-size: #{$titleBaseFontSize + 10}pt
      line-height: #{$titleBaseLineHeight + 10}px

    @media screen and (min-width: $break-large)
      font-size: #{$titleBaseFontSize + 15}pt
      line-height: #{$titleBaseLineHeight + 15}px
</style>



// WEBPACK FOOTER //
// HeaderTitle.vue?94c7b38e